<template>
  <section
    v-tooltip.bottom="t('change_language')"
    class="flex items-center gap-x-3 cursor-pointer"
    @click="usePopoverToggle(popover, $event)"
  >
    <Icon :icon="settings[locale].icon" class="min-h-[30px] min-w-[30px]" />

    <p class="font-semibold text-base lg:flex hidden" :class="textColor">
      {{ t(settings[locale].label) }}
    </p>

    <Icon
      class="rotate-180 min-h-[20px] min-w-[20px]"
      :class="textColor"
      icon="iconamoon:arrow-up-2-bold"
    />
  </section>

  <HealthPopover ref="popover" class="dark:bg-dark-800">
    <ul class="flex flex-col gap-3">
      <li
        v-for="(language, idx) in languages"
        :key="idx"
        class="flex items-center text-base gap-2 hover:text-primary-500 dark:hover:text-primary-200 cursor-pointer"
        :class="
          locale === language.name
            ? 'dark:text-primary-200 text-primary-500'
            : 'dark:text-white text-gray-700'
        "
        @click="setLanguage($event, language.name)"
      >
        <Icon :icon="language.icon" class="min-h-[30px] min-w-[30px]" />
        <p class="font-semibold">{{ t(language.description) }}</p>
      </li>
    </ul>
  </HealthPopover>
</template>

<script setup lang="ts">
  import { Icon } from "@iconify/vue";
  import { ref } from "vue";
  import { useI18n } from "vue-i18n";
  import { loadLocaleMessages } from "@/shared/config/i18n/vue-i18n.ts";
  import { usePopoverHide, usePopoverToggle } from "@/shared/composables/usePopover.ts";
  import HealthPopover from "@/shared/components/utils/HealthPopover.vue";

  const popover = ref();

  const { locale, t } = useI18n();

  defineProps({
    textColor: {
      type: String,
      default: "text-white",
    },
  });

  const settings = ref({
    pt: { label: "portuguese", icon: "twemoji:flag-brazil" },
    en: { label: "english", icon: "twemoji:flag-united-states" },
    es: { label: "spanish", icon: "twemoji:flag-spain" },
  });

  const languages = ref([
    { name: "pt", description: "portuguese", icon: "twemoji:flag-brazil" },
    { name: "en", description: "english", icon: "twemoji:flag-united-states" },
    { name: "es", description: "spanish", icon: "twemoji:flag-spain" },
  ]);

  const setLanguage = async (event: Event, locale: string) => {
    await loadLocaleMessages(locale);

    usePopoverHide(popover.value, event);
  };
</script>
